import { render, staticRenderFns } from "./Del.vue?vue&type=template&id=3f90e059&"
import script from "./Del.vue?vue&type=script&lang=js&"
export * from "./Del.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports